import React, { useState } from 'react'
import clsx from 'clsx'
import { ExpressionFinderComponent } from '@/component'

import { datatableTypes } from '@/typings'

type Props = datatableTypes.DatatableDataStructType

const DatatableColStruct = (props: Props) => {
	const [active, setActive] = useState(false)

	const handleClick = () => {
		if (props.action !== 'click') {
			return
		}
		setActive(active)
		ExpressionFinderComponent.find(props.id, active ? '' : props.content)
	}

	const handleMouseEnter = () => {
		if (props.action !== 'hover') {
			return
		}
		setActive(true)
		ExpressionFinderComponent.find(props.id, props.content)
	}

	const handleMouseLeave = () => {
		if (props.action !== 'hover') {
			return
		}
		setActive(false)
		ExpressionFinderComponent.find(props.id, '')
	}

	return React.createElement(
		props.element,
		{
			style: {
				color: active ? props.activeColor : props.color,
			},
			className: clsx('transition', props.className),
			onClick: handleClick,
			onMouseEnter: handleMouseEnter,
			onMouseLeave: handleMouseLeave,
		},
		Array.isArray(props.content) ? props.content.map((p) => <DatatableColStruct {...p} />) : [props.content],
	)
}

export default DatatableColStruct
